import { DASHBOARD_MESSAGES } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { PropertiesChart } from "@/modules/DashboardTemplate/models/PropertiesChart";
import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { Utils } from "@/shared/utils/utils";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import {
  GRID_CHART_WITH_LEGEND,
  LEGEND_CHART,
  TITLE_CHART
} from "../ChartsConstants";
import { handleClickChart } from "../Utils/handleClick";
import {
  AxisXY,
  OptionsChart
} from "@/modules/DashboardTemplate/models/optionsChart";

@Component({
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      refreshCharts: "getRefreshCharts"
    })
  },
  components: { EmptyState }
})
export default class StackedBarChart extends Vue {
  @Prop({ required: true }) propertiesToChart!: PropertiesChart;

  EMPTY_STATE_HEADER = DASHBOARD_MESSAGES.NO_RESULTS;
  EMPTY_STATE_PARAGRAPH = DASHBOARD_MESSAGES.NOT_FOUND;
  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  chartOptions: OptionsChart = new OptionsChart();
  emptyData = false;

  mounted() {
    this.chart();
  }

  @Watch("refreshCharts")
  @Watch("propertiesToChart", { deep: true })
  onChangeData() {
    this.chart();
  }

  chart() {
    const dataToGraph = this.sectionsOfDashboardStore[
      this.propertiesToChart.indexSectionOfDashboard
    ].collections[this.propertiesToChart.indexCollectionFilter];

    if (Object.keys(dataToGraph.chartData).length === 0) {
      this.emptyData = true;
      return;
    }
    this.emptyData = false;

    const series = dataToGraph.chartData.data.map((item: any) => {
      return {
        name: item.name,
        type: "bar",
        stack: item.stack,
        barWidth: "10%",
        label: {
          show: item.labelBar ? true : false,
          formatter: item.labelBar,
          position: "top",
          color: "black"
        },
        data: item.data
      };
    });
    const groups = Object.values(dataToGraph.chartData.groups);

    let yAxis: AxisXY = { type: "value" };
    let xAxis: AxisXY = {
      type: "category",
      data: dataToGraph.chartData.xAxis,
      axisLabel: {
        rotate: 45
      }
    };
    if (this.propertiesToChart.chartType.includes("horizontal")) {
      yAxis = { type: "category", data: dataToGraph.chartData.xAxis };
      xAxis = {
        type: "value",
        axisLabel: {
          rotate: 45
        }
      };
    }

    const color = Utils.generateColorsTones(
      this.propertiesToChart.chartColor.hex,
      6
    );
    this.chartOptions = {
      color,
      tooltip: { trigger: "item" },
      title: {
        ...TITLE_CHART,
        text: dataToGraph.chartName
      },
      legend: {
        data: groups[groups.length - 1],
        ...LEGEND_CHART
      },
      grid: {
        ...GRID_CHART_WITH_LEGEND
      },
      xAxis,
      yAxis,
      series
    };
  }

  handleClick(event: any) {
    handleClickChart(
      this.propertiesToChart.indexSectionOfDashboard,
      this.propertiesToChart.indexCollectionFilter,
      "stackedColumn",
      event
    );
  }
}
